/**
 * Collection methods
 * -----------------------------------------------------------------------------
 *
 * @namespace collection
 */

import axios from 'axios';
import Flickity from 'flickity';
import detectIt from 'detect-it';

var createHistory = require('history').createBrowserHistory;

var history = createHistory();

var collectionMethods = {
  data: function data() {
    return {
      isCollectionAjaxed: false,
      collection: {
        title: null,
        description: null,
        image: null,
        products: [],
        pagination: {},
        activeFilters: [],
        total_count: 0
      }
    };
  },


  methods: {
    _initCollection: function _initCollection() {
      var isCollectionAjaxed = $('[data-template="collection"]').data('collection-ajaxed');

      // stop parsing if we are not in the collection template
      if (app.currentTemplate !== 'collection') {
        return;
      }

      // check collection section settings => enable ajax filters
      if (isCollectionAjaxed) {
        app.isCollectionAjaxed = true;
      } else {
        $(app.selectors.productObj).each(function (index, itemK) {
          var productObj = $(itemK).html();
          var productData = JSON.parse(productObj);
          var product = productData.product;
          var optionsWithValues = productData.options_with_values;
          product.current_variant = product.variants[0];
          product.options_with_values = optionsWithValues;
          // assign the product cart limit
          product.tags.forEach(function (tag) {
            if (tag.match('cart-limit')) {
              var cartLimit = tag.replace('cart-limit-', '');
              product.cart_limit = parseFloat(cartLimit);
              // console.log(product);
            }
          });
          app.collection.products.push(product);
          app.showProducts = true;
        });
      }
      setTimeout(function () {
        app.collection.total_count = app.collection.products.length;
        if (app.collection.products.length === 0) {
          $('[data-check-length]').removeClass('d-none');
        }
        // const templatetObj = $(app.selectors.collectionTemplate).html();
        // const templatetData = JSON.parse(templatetObj);
        // $(templatetData).each((index, itemX) => {
        //   // eslint-disable-next-line eqeqeq
        //   if (itemX.link == app.collection.handle) {
        app.templateCheck = true;
        //   }
        // });

        if (app.collection.image != null) {
          if (app.collection.image.indexOf('/no-image') === -1) {
            app.imageCheck = true;
          }
        }
      }, 1000);
      app._initFilters();
    },
    _showVariant: function _showVariant(event) {
      var value = event.currentTarget.value;
      var $carousel = $(event.currentTarget).closest('.card').find('[data-flickity]');

      if ($carousel.length > 0) {
        var flkty = Flickity.data($carousel[0]);
        var cellElements = flkty.getCellElements();

        cellElements.forEach(function (element, index) {
          var imgAlt = $(element).data('variant-title');
          if (imgAlt === value) {
            flkty.selectCell(index, true, false); // value, isWrapped, isInstant
          }
        });
      }
    },
    _initFilters: function _initFilters() {
      // const location = history.location;
      Shopify.queryParams = {};

      // Listen for changes to the current location
      history.listen(function (location, action) {
        // location is an object like window.location
        // console.log(action, location.pathname, location.state)
        app._runFilters(); // run every time history changes
      });

      // run one time during 1st page load or upon page refresh
      app._runFilters();
    },
    _runFilters: function _runFilters() {
      app._urlParams();
      app._mapFilters();
      var url = app._filtersCreateUrl();
      if (app.isCollectionAjaxed) {
        app._getcollectionInfo();
        app._getCollFilteredProducts(url);
      }
    },


    /**
     * Event when an input filter changes
     *
     */
    _parseFilters: function _parseFilters(event) {
      var filterType = $(event.currentTarget).data('filter-type');
      var collectionHandle = $(event.currentTarget).data('handle');
      var selectedTags = [];

      // Collection filtering
      if (filterType === 'collection') {
        $('.collection-category li').removeClass('active');
        $(event.currentTarget).closest('li').addClass('active');

        var newURL = '';
        var search = $.param(Shopify.queryParams);
        var href = $(event.currentTarget).attr('href');

        if (app.isCollectionAjaxed) {
          if (!search.length) {
            href += '?';
          }
          app._filterAjaxCall(href);
        } else {
          newURL = collectionHandle;
          if (selectedTags.length) {
            newURL += '/' + selectedTags.join('+');
          }
          delete Shopify.queryParams.page;
          search = $.param(Shopify.queryParams);
          if (search.length) {
            newURL += '?' + search;
          }
          location.href = newURL;
        }
        app._clearAllFilters();
        setTimeout(function () {
          var colHandle = app.collection.handle;
          // eslint-disable-next-line shopify/jquery-dollar-sign-reference
          var SpecialCaseFilters = $('[data-specialcase="true"]');
          SpecialCaseFilters.each(function () {
            var allowedColList = $(this).attr('data-collection_list');
            if (allowedColList.indexOf(colHandle) > -1) {
              $(this).removeClass('d-none');
            } else {
              $(this).addClass('d-none');
              $(this).find('input[type="radio"]').prop('checked', false);
            }
          });
        }, 1500);
      }

      // Tag filter
      if (filterType === 'tag') {
        $('[data-filter]').removeClass('active');
        $('[data-filter]:checked').each(function (i) {
          selectedTags.push(this.value);
          $(this).addClass('active');
        });

        app.collection.activeFilters = selectedTags;

        if (selectedTags.length) {
          Shopify.queryParams.constraint = selectedTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }

        if (app.isCollectionAjaxed) {
          app._filterAjaxCall();
        } else {
          delete Shopify.queryParams.page;
          location.search = $.param(Shopify.queryParams).replace(/%2B/g, '+');
        }
      }

      // Sort filter
      if (filterType === 'sort') {
        var sortValue = $(event.currentTarget).val();

        if (sortValue) {
          Shopify.queryParams.sort_by = sortValue;
        } else {
          delete Shopify.queryParams.sort_by;
        }

        if (app.isCollectionAjaxed) {
          app._filterAjaxCall();
        } else {
          var _search = $.param(Shopify.queryParams);
          if (_search.length) {
            location.search = $.param(Shopify.queryParams);
          } else {
            location.href = location.pathname;
          }
        }
      }

      // Collection pagination
      if (filterType === 'pagination') {
        var url = $(event.currentTarget).attr('href').match(/page=\d+/g);
        Shopify.queryParams.page = parseInt(url[0].match(/\d+/g), 10);

        if (url && (Shopify.queryParams.page === parseInt(url[0].match(/\d+/g), 10), Shopify.queryParams.page)) {
          if (app.isCollectionAjaxed) {
            url = app._filtersCreateUrl();
            history.push(url, {
              param: Shopify.queryParams
            });
            app._getNewTitle(Shopify.queryParams);
            app._getCollFilteredProducts(url);
            // if (navigator.userAgent.search("MSIE") > -1) {
            location.reload();
            // }
          }
        }
      }

      // map all filters
      app._mapFilters();
    },


    /**
     * Get all parameters from URL and map them to all inputs in page
     *
     */
    _mapFilters: function _mapFilters() {
      // Read url parameters and map keys to filters
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i += 1) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      // sorting: select value
      if (Shopify.queryParams.sort_by) {
        $('[data-filter-sort]').val(Shopify.queryParams.sort_by);
      } else {
        $('data-filter-sort').val('manual');
      }

      // tags: select values
      if (Shopify.queryParams.constraint) {
        var selectedTags = [];
        $.each(Shopify.queryParams.constraint.split('+'), function (i, val) {
          if (val) {
            selectedTags.push(val);
          }
        });

        app.collection.activeFilters = selectedTags;
      }
    },
    _filtersCreateUrl: function _filtersCreateUrl(e) {
      var b = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      return e ? b !== '' ? e + '?' + b : e : location.pathname + '?' + b;
    },
    _filterAjaxCall: function _filterAjaxCall(e) {
      delete Shopify.queryParams.page;
      var url = app._filtersCreateUrl(e);
      history.push(url, {
        param: Shopify.queryParams
      });
      app._getNewTitle(Shopify.queryParams);
      app._getCollFilteredProducts(url);
      // if (navigator.userAgent.search("MSIE") > -1) {
      location.reload();
      // }
    },
    _urlParams: function _urlParams() {
      if (Shopify.queryParams === {}, location.search.length) {
        for (var i, e = 0, t = location.search.substr(1).split('&'); e < t.length; e += 1) {
          i = t[e].split('='), i.length > 1 && (Shopify.queryParams[decodeURIComponent(i[0])] = decodeURIComponent(i[1]));
        }
      }
    },
    _getNewTitle: function _getNewTitle(queryParams) {
      var tagParams = '';
      var pageParams = '';
      var finalParams = '';
      var title = document.title;
      var collection = title.slice(0, title.indexOf('-')).replace(/\s/g, '');
      var siteTitle = title.slice(title.lastIndexOf('-') + 1).replace(/\s/g, '');

      if (queryParams.constraint) {
        tagParams = ' - Tagged "' + queryParams.constraint.replace(/\+/g, ', ') + '"';
      }

      if (queryParams.page) {
        pageParams = ' - Page ' + queryParams.page;
      }

      finalParams = '' + tagParams + pageParams;
      var newTitle = '' + collection + finalParams + ' - ' + siteTitle;
      document.title = newTitle;
    },
    _clearAllFilters: function _clearAllFilters() {
      delete Shopify.queryParams.constraint;
      delete Shopify.queryParams.q;
      app.collection.activeFilters = [];

      if (app.isCollectionAjaxed) {
        $('[data-filter]').attr('checked', false);
        $('[data-filter]').removeClass('active');
        $('.collection-filters .card .list-unstyled').each(function () {
          // eslint-disable-next-line eqeqeq
          if ($(this).find('.active').length == 0) {
            $(this).closest('.card').find('.card-body').removeClass('show');
            $(this).closest('.card').find('.card-header').addClass('collapsed').attr('aria-expanded', false);
          }
        });
        app._filterAjaxCall();
      } else {
        location.search = $.param(Shopify.queryParams);
      }
      $('#filtersCollapse input[type="radio"], #filtersCollapse input[type="checkbox"]').prop('checked', false);
    },
    _getCollFilteredProducts: function _getCollFilteredProducts(url) {
      var limit = $('[data-template="collection"]').data('pagination-limit');
      var search = $.param(Shopify.queryParams);
      app.collection.products = [];
      app.isLoading = true;

      url += search.length ? '&view=products.json' : 'view=products.json';

      // for Shopify theme editor
      if (Shopify.designMode) {
        url = '/admin/products.json?limit=' + limit;
      }

      app.collection.count = 0;
      axios.get(url).then(function (response) {
        app.isLoading = false;
        var productsData = [];

        if (Shopify.designMode) {
          productsData = response.data.products;
        }

        // eslint-disable-next-line eqeqeq
        if (response.data.products != undefined) {
          // add default current_variant object
          response.data.products.forEach(function (itemK) {
            var product = itemK.product;
            product.collection = '-';

            // add default current_variant object
            product.current_variant = product.variants[0];

            // add product options
            product.options_with_values = itemK.options_with_values;

            // add product count
            app.collection.count = itemK.count;

            // add cart limit tag
            product.tags.forEach(function (tag) {
              if (tag.match('cart-limit')) {
                var cartLimit = tag.replace('cart-limit-', '');
                product.cart_limit = parseFloat(cartLimit);
              }
              if (tag.match('collection-')) {
                var collection = tag.replace('collection-', '').replace('_', ' ').replace('_', ' ');
                product.collection = collection;
              }
            });

            productsData.push(product);
            // let priceZero = true;
            // product.variants.forEach((variant) => {
            //   // eslint-disable-next-line eqeqeq
            //   if (variant.price == 0) {
            //     priceZero = false;
            //   }
            // });

            // // exclude products that have the app.productExcludeTag (theme settings)
            // // eslint-disable-next-line eqeqeq
            // if (product.tags.indexOf(app.productExcludeTag) === -1) {
            //   // eslint-disable-next-line eqeqeq
            //   if (priceZero) {
            //     productsData.push(product);
            //   }
            // }
          });
        }

        app.collection.products = productsData;
        app.showProducts = true;

        app.collection.total_count = app.collection.products.length;

        // app.templateCheck = false;
        // const templatetObj1 = $(app.selectors.collectionTemplate).html();
        // const templatetData1 = JSON.parse(templatetObj1);
        // $(templatetData1).each((index, itemTest) => {
        // eslint-disable-next-line eqeqeq
        // if (itemTest.link == app.collection.handle) {
        app.templateCheck = true;
        //   }
        // });

        if (app.collection.image != null) {
          if (app.collection.image.indexOf('/no-image') === -1) {
            app.imageCheck = true;
          }
        }

        if (app.collection.products.length === 0) {
          $('[data-check-length]').removeClass('d-none');
        }

        setTimeout(function () {
          $('[data-collection-group]').removeClass('d-none');
          if ($('[data-handle="satin-nickel"]').length > 0) {
            $('[data-handle="satin-nickel"]').trigger('click');
          }
          // eslint-disable-next-line eqeqeq
          if (app.collection.handle == 'connected-by-august' || app.collection.handle == 'google-assistant') {
            if ($('[data-handle="connected-by-august"]').length > 0) {
              $('[data-handle="connected-by-august"]').trigger('click');
            }
            // eslint-disable-next-line eqeqeq
          } else if (app.collection.handle == 'xfinity') {
            if ($('[data-handle="zigbee"]').length > 0) {
              $('[data-handle="zigbee"]').trigger('click');
            }
            // eslint-disable-next-line eqeqeq
          } else if (app.collection.handle == 'z-wave-systems' || app.collection.handle == 'samsung-smartthings') {
            if ($('[data-handle="z-wave-plus"]').length > 0) {
              $('[data-handle="z-wave-plus"]').trigger('click');
            }
            if ($('[data-handle="z-wave"]').length > 0) {
              $('[data-handle="z-wave"]').trigger('click');
            }
          }
        }, 200);

        app._getcollectionPagination(url);
        // console.log(app.collection.products)

        // reinitialize product reviews for each grid item
        app._getCollectionReviews();

        // reinitialize tooltips but only for desktop
        if (!detectIt.hasTouch) {
          setTimeout(function () {
            $('[data-toggle="tooltip"]').tooltip();
          }, 100);
        }

        $('html').animate({
          scrollTop: $('html').offset().top
        }, 400);
        // unlock window - fix scrolltop common problem
        $(window).bind('mousewheel', function () {
          $('html').stop();
        });
        return response;
      }).catch(function (error) {
        // console.log(error);
        throw error;
      });
    },
    _getcollectionInfo: function _getcollectionInfo() {
      var url = window.location.href.replace(window.location.search, '');
      url += '?view=json';
      axios.get(url).then(function (response) {
        var collectionData = response.data;
        app.collection.title = collectionData.title;
        app.collection.handle = collectionData.handle;
        app.collection.description = collectionData.description;
        app.collection.image = collectionData.image;
        app.collection.url = collectionData.url;
        // app.collection.count = collectionData.count;
        return response;
      }).catch(function (error) {
        // console.log(error);
        throw error;
      });
    },
    _getcollectionPagination: function _getcollectionPagination(url) {
      url += '&view=paginate.json';

      axios.get(url).then(function (response) {
        app.collection.pagination = response.data;
        return response;
      }).catch(function (error) {
        // console.log(error);
        throw error;
      });
    },
    _loadMore: function _loadMore(event) {
      var url = $(event.currentTarget).attr('href');
      url = url.replace('paginate', 'products');
      app.isLoading = true;

      axios.get(url).then(function (response) {
        $.each(response.data, function (key, item1) {
          item1.current_variant = item1.variants[0];

          // exclude products that have the app.productExcludeTag (theme settings)
          if (item1.tags.indexOf(app.productExcludeTag) === -1) {
            app.collection.products.push(item1);
          }
        });

        app.isLoading = false;
        app._getcollectionPagination(url);
        return response;
      }).catch(function (error) {
        // console.log(error);
        throw error;
      });
    },
    _getValue: function _getValue(event) {
      var cur_var = $(event.currentTarget).val();
      cur_var = cur_var.replace('-', ' ').replace('-', ' ').replace('-', ' ').replace('-', ' ').replace('-', ' ');
      $(event.currentTarget).parents('[product_grid]').find('label').removeClass('active');
      $(event.currentTarget).closest('label').addClass('active');
      $(event.currentTarget).parents('[product_grid]').find('[data-selected_opt]').text(cur_var);
      $(event.currentTarget).parents('[data-product-form]').find('[data-selected_product]').text(cur_var);
    }
  }
};

export default collectionMethods;